function r(r,n){for(let t=0;t<r.length;t++)null===r[t]&&(r[t]=t?r[t-1]:n());return r}const n=r=>Array.isArray(r)?r:[r];export{r as hydrateKeyframes,n as keyframesList};
